export const formatPrice = (price: number, currency: string) => {
  try {
    return new Intl.NumberFormat(currency === 'NGN' ? 'en-NG' : 'en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  } catch {
    return `${currency} ${price}`;
  }
};

export const formatDate = (date?: string | null) => {
  if (!date) return '—';
  const d = new Date(date);
  if (isNaN(d.getTime())) return date;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const formatDateTime = (date?: string | null) => {
  if (!date) return '—';
  const d = new Date(date);
  if (isNaN(d.getTime())) return date;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) +
    ' ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
};

export const formatCurrencyAmount = (amount: number, currency: string) =>
  `${currency} ${Number(amount).toLocaleString()}`;

export const timeAgo = (date: string | undefined) => {
  if (!date) return '';
  const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return formatDate(date);
};

export const statusLabel = (status: string) =>
  status.split('_').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

export const parseResidents = (residentName: string | null, unit: string | null): { name: string; unit: string }[] => {
  if (!residentName) return [];
  try {
    const parsed = JSON.parse(residentName);
    if (Array.isArray(parsed)) {
      return parsed.map((e) => typeof e === 'string' ? { name: e, unit: unit || '' } : { name: e?.name ?? '', unit: e?.unit ?? unit ?? '' }).filter((e) => e.name);
    }
    if (parsed && typeof parsed === 'object' && typeof parsed.name === 'string') {
      return [{ name: parsed.name, unit: parsed.unit || unit || '' }];
    }
  } catch { /* fall through */ }
  return [{ name: residentName, unit: unit || '' }];
};

export const formatFileSize = (bytes: number) => {
  if (!bytes && bytes !== 0) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
